export default __webpack_public_path__ + "static/default-2_500x500-06afd179acfffe3275f81c6fc9845404.png";